<article
  class="overflow-hidden rounded-xl border bg-white shadow-header z-10 relative"
  [attr.aria-label]="entry.documentDescription || 'Journal entry'"
>
  <header class="border-b px-5 py-4 flex items-center gap-2">
    <h4 class="m-0 text-base font-bold text-midnight line-clamp-2 flex-grow">
      @if (isCancelAct) { Cancellation Act } @else {
      {{ entry.documentDescription || 'Journal entry' }}
      }
    </h4>
    @if (!isFinalized) {
    <div class="flex items-center gap-2">
      <button
        class="btn btn-xs btn-outline normal-case rounded-full btn-error"
        (click)="onDeleteEntry()"
      >
        Delete
      </button>
      <button
        type="button"
        class="btn btn-xs btn-outline normal-case rounded-full shrink-0"
        (click)="onEditEntry()"
      >
        Edit
      </button>
    </div>
    } @else {
    <button
      type="button"
      class="btn btn-xs btn-outline normal-case rounded-full shrink-0"
      (click)="onAddSupplementalEntry()"
    >
      Add supplemental entry
    </button>
    }
    <!-- Preview pdf button -->
    @if (!isCancelAct) {
    <et-journal-preview-pdf-btn [seal]="entry"></et-journal-preview-pdf-btn>
    }
  </header>
  <div class="grid grid-cols-2 gap-x-8 gap-y-4 p-5">
    @if (isEntry) {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Notarial act</span
      >
      <span class="text-sm text-midnight">{{ entry.notorialAct || '—' }}</span>
    </div>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Page</span
      >
      <span class="text-sm text-midnight">{{ entry.pageNumber || '—' }}</span>
    </div>
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Fee</span
      >
      <span class="text-sm text-midnight">{{
        entry.feeCharged || journalFees()
          | currency : 'USD' : 'symbol' : '1.2-2'
      }}</span>
    </div>
    }
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Signer</span
      >
      <span class="text-sm text-midnight line-clamp-4">{{
        linkedSigner?.name || '—'
      }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >IP address</span
      >
      <span class="text-sm text-midnight line-clamp-4">{{
        entry.ipAddress || '—'
      }}</span>
    </div>

    @if (entry.cancelActUtcDate) {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Date of cancellation</span
      >
      <span class="text-sm text-midnight">{{
        entry.cancelActUtcDate | date : 'short'
      }}</span>
    </div>
    }

    <!-- Notarized date only shown for entry type -->
    @if (isEntry) {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Notarized</span
      >
      <span class="text-sm text-midnight">{{
        entry.notarizationDate | date : 'short'
      }}</span>
    </div>
    }

    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Created</span
      >
      <span class="text-sm text-midnight">{{
        entry.utcCreatedOn | date : 'short'
      }}</span>
    </div>

    @if (entry.notes) {
    <div class="flex flex-col gap-1">
      <span class="text-xs font-semibold uppercase tracking-wide text-light"
        >Notes</span
      >
      <span class="text-sm text-midnight line-clamp-4 whitespace-pre-line">{{
        entry.notes
      }}</span>
    </div>
    }
  </div>
</article>

<!-- Supplemental notes -->
@if (entry.supplementalNotes && entry.supplementalNotes.length > 0) {
<div class="rounded-b-xl border bg-white shadow-header px-5 py-4 ml-4 -mt-2.5">
  <p class="text-xs font-semibold uppercase tracking-wide text-light mb-6 mt-2">
    Supplemental notes
  </p>
  <div class="grid grid-cols-[108px_1fr] gap-x-4 gap-y-6">
    @for (note of entry.supplementalNotes; track note.utcCreatedOn) {
    <p class="text-xs leading-5 text-light m-0">
      {{ note.utcCreatedOn | date : 'short' }}
    </p>
    <p class="text-sm text-midnight m-0 whitespace-pre-line">
      {{ note.supplementalNote }}
    </p>
    }
  </div>
</div>
}

<!-- Delete signer modal template -->
<ng-template #deleteEntryModal>
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex items-center justify-between">
      <h3 class="flex items-center gap-3 text-lg font-bold">Delete entry</h3>
      <button class="self-start" mat-dialog-close>
        <img src="assets/icons/close.svg" alt="Close" width="16" height="16" />
      </button>
    </div>
    <!-- Message -->
    <div>
      <p>
        Are you sure you want to delete @if (isCancelAct) {
        <strong>cancellation act</strong>? } @else {
        <strong>{{ entry.documentDescription || '—' }}</strong
        >? }
      </p>
      <p>This action cannot be undone.</p>
    </div>
    <!-- Buttons -->
    <div class="flex justify-center items-center gap-4">
      <button
        matDialogClose
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-outline min-w-[160px] text-base"
      >
        Cancel
      </button>
      <button
        (click)="deleteEntry()"
        class="normal-case h-10 min-h-[40px] rounded-full btn btn-primary min-w-[160px] text-base"
      >
        @if (isDeletingEntry()) {
        <et-atoms-spinner size="small"></et-atoms-spinner>
        } @else { Delete }
      </button>
    </div>
  </div>
</ng-template>
